import type { AdUnit } from '../../Entities/AdUnit.entity';
import { PATH_BASE } from '../Constants';
import { DMPU_SIZE, MPU_SIZE } from '../UnitSizes';

export const ReviewMobileDMPU1 = {
  path: `${PATH_BASE}/DMPU1_UK`,
  sizes: [MPU_SIZE, DMPU_SIZE],
  defaultHeight: MPU_SIZE[1],
  minHeight: 250,
  responsiveSizeMap: {
    1440: [],
    1280: [],
    1024: [],
    768: [MPU_SIZE],
    0: [MPU_SIZE, DMPU_SIZE],
  },
  useSizeMap: true,
  trackingData: {
    renderEvent: {
      name: 'UK_webapp_slot_render_ended',
      label: 'DMPU 1 UK banner is loaded',
    },
    impressionEvent: {
      name: 'UK_webapp_impression_viewable',
      label: 'DMPU 1 UK banner is loaded',
    },
  },
} as const satisfies AdUnit;
